import {
  CompanyApi,
  Configuration as PrtimesConfiguration,
} from '@openapi/prtimes';
import {
  PreviewPressReleaseApi,
  Configuration as PressReleaseConfiguration,
} from '@openapi/press-release';

export const companyApi = new CompanyApi(
  new PrtimesConfiguration({
    basePath: '/api',
    credentials: 'same-origin',
  }),
);

export const previewPressReleaseApi = new PreviewPressReleaseApi(
  new PressReleaseConfiguration({
    basePath: '/api/press_release.php',
    credentials: 'same-origin',
  }),
);
